var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9551 19.6826C18.9551 16.4114 21.6165 13.75 24.8877 13.75C28.1589 13.75 30.8203 16.4114 30.8203 19.6826C30.8203 22.9539 28.1589 25.6152 24.8877 25.6152C21.6165 25.6152 18.9551 22.9539 18.9551 19.6826ZM26.2061 26.9336C28.4916 26.9336 30.6448 27.8418 32.269 29.491C33.8853 31.1321 34.7754 33.2983 34.7754 35.5908C34.7754 35.9549 34.4803 36.25 34.1162 36.25H15.6592C15.2951 36.25 15 35.9549 15 35.5908C15 33.2983 15.8901 31.1321 17.5064 29.491C19.1306 27.8418 21.2838 26.9336 23.5693 26.9336H26.2061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.12625840625bd8ce37b66ac0dbde8e97.svg";
export { ForwardRef as ReactComponent };